import { render, staticRenderFns } from "./VlanFormComponent.vue?vue&type=template&id=5486532f&scoped=true"
import script from "./VlanFormComponent.vue?vue&type=script&lang=js"
export * from "./VlanFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5486532f",
  null
  
)

export default component.exports